"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _isCredibleDate = _interopRequireDefault(require("./is-credible-date"));
/** @deprecated use native or date-fns */
var DateFormatter = {
  format: function format(date, _temp) {
    var _ref = _temp === void 0 ? {} : _temp,
      defaultText = _ref.defaultText,
      inputFormat = _ref.inputFormat,
      _ref$outputFormat = _ref.outputFormat,
      outputFormat = _ref$outputFormat === void 0 ? 'MMM DD, YYYY' : _ref$outputFormat;
    if (!(0, _isCredibleDate["default"])(date)) {
      return defaultText;
    }
    return (0, _momentTimezone["default"])(date, inputFormat).format(outputFormat);
  }
};
var _default = exports["default"] = DateFormatter;